import React, { useContext } from 'react';
import { injectIntl } from "react-intl";
import FormContext from "formContext";
import SelectField from "@FormElements/SelectField";

function JobTitleSelectField({ intl, settings, ...rest }) {
  const { additionalData, currentStep, setFormData, formData, setErrors } = useContext(FormContext);
  let jobTypes = [];
  additionalData.specialisms && Object.values(additionalData.specialisms.Specialisms).forEach(specialism => {
    if (specialism.Name === formData[currentStep]['specialism']) {
      jobTypes = specialism.lstJobTitles;
    }
  });
  if (jobTypes.length === 0) {
    return null;
  }

  let jobTypesOptions = [];
  jobTypesOptions.push({ value: "", label: intl.formatMessage({ id: 'SelectField.EmptyOption.Label' }) });
  jobTypes.forEach((jobType) => {
    jobTypesOptions.push({
      value: jobType.JobTitleCode,
      label: jobType.JobTitleValue,
    });
  });
  settings.options = jobTypesOptions;
  if (settings.errors && settings.errors.hasOwnProperty(settings.name)) {
    settings.errors["job_title_id"] = settings.errors[settings.name];
  }

  rest.onChange = e => {
    const { value } = e.target;
    setErrors();
    const match = jobTypesOptions.find((el) => el.value === value);
    if (match && value !== "") {
      setFormData(prev => {
        if (!prev[currentStep][settings.name]) {
          prev[currentStep][settings.name] = '';
        }
        prev[currentStep][settings.name] = match.label;
        prev[currentStep]['job_title_id'] = match.value;
        return {
          ...prev
        }
      });
    } else {
      setFormData(prev => {
        if (!prev[currentStep]) {
          prev[currentStep] = {};
        }
        prev[currentStep][settings.name] = "";
        prev[currentStep]['job_title_id'] = "";
        return {
          ...prev
        }
      });
    }
  };

  return (
    (
      <SelectField
        settings={settings}
        {...rest}
        name="job_title_id"
      />
    )
  );
}
export default injectIntl(JobTitleSelectField);
